const Contact = require('@/lib/Contacts/Contact');
const { toString } = require('@/functions/transform');

/**
 * @constructor
 */
const SoldGiftVoucherData = function () {
    this.deliveryType = null;
    /**
     * @type {Contact}
     */
    this.recipientContact = new Contact();
    this.recipientMessage = '';
};

SoldGiftVoucherData.prototype = {
    getHydrationMap() {
        return {
            deliveryType: toString,
            recipientContact: {
                model: Contact,
            },
            recipientMessage: toString,
        };
    },

    /**
     * @return {{deliveryType: *, recipientContact: null, recipientMessage: *}}
     */
    toServerData: function toServerData() {
        return {
            deliveryType: this.deliveryType,
            recipientContact: this.recipientContact.isEmpty() ? null : this.recipientContact.toServerData(),
            recipientMessage: this.recipientMessage,
        };
    },
};

module.exports = SoldGiftVoucherData;
